import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49f8ea43&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=49f8ea43&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8ea43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f8ea43')) {
      api.createRecord('49f8ea43', component.options)
    } else {
      api.reload('49f8ea43', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49f8ea43&scoped=true", function () {
      api.rerender('49f8ea43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CursorPagination/index.vue"
export default component.exports